import { Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import typography from "../../../theme/typography";

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

interface NetworkTabsProps {
  tabValue: number;
  handleChangeTabValue: (event: React.SyntheticEvent, newValue: number) => void;
  isEntity?: boolean;
  isOwnNetworkTab?: boolean;
}

const NetworkTabs = ({ tabValue, handleChangeTabValue, isEntity, isOwnNetworkTab }: NetworkTabsProps) => {
  const { t } = useTranslation();
  return (
    <Tabs
      value={tabValue}
      onChange={handleChangeTabValue}
      aria-label="basic auto tabs"
      sx={{
        minHeight: "unset",
        "& .MuiTabs-flexContainer": {
          gap: "16px",
        },
        "& .MuiTabs-indicator": {
          height: "3px",
        },
      }}
    >
      <Tab
        label={t("components.networkController.followers")}
        {...a11yProps(0)}
        sx={{
          padding: "0 0 8px",
          minHeight: "unset",
          ...typography.body16Regular,
          textTransform: "capitalize",
        }}
      />
      <Tab
        label={t("components.networkController.following")}
        {...a11yProps(1)}
        sx={{
          padding: "0 0 8px",
          minHeight: "unset",
          ...typography.body16Regular,
          textTransform: "capitalize",
        }}
      />
      {isOwnNetworkTab && (
        <Tab
          label={t("components.networkController.members")}
          {...a11yProps(2)}
          sx={{
            padding: "0 0 8px",
            minHeight: "unset",
            ...typography.body16Regular,
            textTransform: "capitalize",
          }}
        />
      )}
    </Tabs>
  );
};

export default NetworkTabs;
